import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wrapper my-4 py-5 pb-10 md:pb-0" }
const _hoisted_2 = { class: "rounded my-2 lg:rounded-2xl lg:shadow-xs drop-shadow-sm" }
const _hoisted_3 = { class: "max-w-sm mx-auto" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "transition duration-150 font-bold text-lg group-hover:text-gray-200 dark:group-hover:text-gray-700" }, "+", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "bg-gray-100 dark:bg-gray-800 p-3 rounded" }
const _hoisted_10 = { class: "text-lg appFont mt-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-md appFont mt-2" }
const _hoisted_13 = { class: "mt-2 flex items-center space-x-2" }
const _hoisted_14 = {
  key: 3,
  class: "mt-10 text-center"
}
const _hoisted_15 = { class: "appFont text-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Separator = _resolveComponent("Separator")!
  const _component_BrowserLink = _resolveComponent("BrowserLink")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_Trash = _resolveComponent("Trash")!
  const _component_BioLinkMeta = _resolveComponent("BioLinkMeta")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.canAddMore)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: _normalizeClass({'hidden':!_ctx.show}),
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_Input, {
                modelValue: _ctx.form.fields.real_url,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.fields.real_url) = $event)),
                modelModifiers: { lazy: true },
                placeholder: "URL Address",
                class: "mt-3"
              }, null, 8, ["modelValue"]),
              (Object.keys(_ctx.errors).includes('real_url'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.form.errors.real_url[0]), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                onClick: _ctx.submit,
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  (!_ctx.processing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Add')), 1))
                    : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false)),
                "gray-theme": true,
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Separator)
            ], 34))
          : _createCommentVNode("", true),
        (_ctx.canAddMore && !_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = true)),
              class: "cursor-pointer transition hover:bg-gray-100 bg-opacity-25 dark:hover:bg-gray-800 duration-150 group hover:border-gray-200 dark:hover:border-gray-700 border-2 border-dashed border-gray-100 dark:border-gray-800 text-gray-100 dark:text-gray-800 p-3 my-2 rounded text-center"
            }, _hoisted_7))
          : _createCommentVNode("", true),
        (!_ctx.fetching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: link,
                  class: "py-3 my-2 w-full"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_BrowserLink, {
                      href: _ctx.appUrl(link.app_url),
                      class: "transition duration-150 text-primary-400 dark:bg-gray-900 hover:dark:bg-gray-700 p-1 px-2 !w-full rounded block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.real_url), 1)
                      ]),
                      _: 2
                    }, 1032, ["href"]),
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('Meta Preview')) + ":", 1),
                    (!link.meta || Object.keys(link.meta).length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('No WiZZL meta tags found')), 1),
                          _createVNode(_component_BrowserLink, {
                            class: "text-sm text-primary-400",
                            href: _ctx.$supportLink('/how-to-use-wizzl-meta-tags')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('Check the documentation')), 1)
                            ]),
                            _: 1
                          }, 8, ["href"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        onClick: ($event: any) => (_ctx.refresh(link)),
                        class: "w-min"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.refreshing_ids.includes(link.id))
                            ? (_openBlock(), _createBlock(_component_Refresh, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_tippy, {content: 'Refresh meta tags'}]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        onClick: ($event: any) => (_ctx.destroy(link)),
                        class: "w-min bg-red-400 hover:bg-red-300 focus:bg-red-500 active:focus:bg-red-500"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.deleting_ids.includes(link.id))
                            ? (_openBlock(), _createBlock(_component_Trash, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_tippy, {content: 'Delete link'}]
                      ])
                    ])
                  ]),
                  (link.meta && Object.keys(link.meta).length > 0)
                    ? (_openBlock(), _createBlock(_component_BioLinkMeta, {
                        key: 0,
                        link: link
                      }, null, 8, ["link"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t('Loading')) + "... ", 1),
                _createVNode(_component_Spinner, { class: "" })
              ])
            ]))
      ])
    ])
  ]))
}